import type { MouseEvent } from 'react';
import {
  type BillingProfileManagementPath,
  normalizeBillingProfilePathname,
} from '../constants/billingProfilePaths';
import { scrollBillingManageIntoView } from './billingScroll';

/** Location state set when navigating to billing so the page scrolls to the manage section after mount. */
export const BILLING_SCROLL_TO_MANAGE_LOCATION_STATE = {
  scrollToBillingManage: true,
} as const;

export type BillingScrollToManageLocationState = typeof BILLING_SCROLL_TO_MANAGE_LOCATION_STATE;

function hasScrollToBillingManageState(
  state: unknown,
): state is BillingScrollToManageLocationState {
  return (
    typeof state === 'object' &&
    state !== null &&
    'scrollToBillingManage' in state &&
    (state as BillingScrollToManageLocationState).scrollToBillingManage === true
  );
}

/**
 * Handles "Open billing" / payment CTAs: same-route clicks scroll to the manage anchor;
 * cross-route clicks fall through to the Link with location state.
 */
export function handleBillingManagementLinkClick(
  e: MouseEvent<HTMLAnchorElement>,
  pathname: string,
  billingPath: BillingProfileManagementPath,
): void {
  if (normalizeBillingProfilePathname(pathname) === billingPath) {
    e.preventDefault();
    scrollBillingManageIntoView();
  }
}

export { hasScrollToBillingManageState };
